import auth from '../../../config/app-specific-config/auth';
import * as types from './zoom-actions-types';
import { axiosInstance } from '../../../config/app-specific-config/axiosConfig';
import { setDsrZoomLinkIsActive } from '../../digital-sales-room/actions/dsr-actions';

// Set Zoom call in session
export const setZoomCallInSession = (p) => {
	return {
		type: types.SET_ZOOM_CALL_IN_SESSION,
		payload: p
	};
}

export const setZoomCallCurrentlyActive = (p) => {
	return {
		type: types.SET_ZOOM_CALL_CURRENTLY_ACTIVE,
		payload: p
	};
}

// Get Zoom JWT Token
export const getZoomJwtTokenSuccess = (response) => {
	return {
		type: types.GET_ZOOM_JWT_TOKEN_SUCCESS,
		payload: response.data
	};
};

export const getZoomJwtTokenFailure = (error) => {
	return {
		type: types.GET_ZOOM_JWT_TOKEN_FAILURE,
		error
	};
};

export const getZoomJwtTokenRequest = () => {
	return {
		type: types.GET_ZOOM_JWT_TOKEN_REQUEST
	};
};

export function getZoomJwtToken(zoomJwtMetadata) {

	return async (dispatch) => {
		dispatch(getZoomJwtTokenRequest());
		try {
			const url = `/integrations/zoom/get-launch-token`;
			const headers = await auth.getAccessToken();
			const response = await axiosInstance.post(
				url,
				{zoomJwtMetadata},
				{ headers }
			);
			
		
			dispatch(getZoomJwtTokenSuccess(response));
		} catch (error) {
			dispatch(getZoomJwtTokenFailure(error));
		}
	};
}

export const getZoomJwtTokenReset = () => {
	return {
		type: types.GET_ZOOM_JWT_TOKEN_RESET
	};
};

export function resetGetZoomJwtToken() {

	return async (dispatch) => {
	
		try {
			dispatch(getZoomJwtTokenReset());

		} catch (error) {
			dispatch(getZoomJwtTokenFailure(error));
		}
	};
}

// Create Zoom link
export const manageDsrZoomLinkSuccess = (response) => {
	return {
		type: types.MANAGE_ZOOM_MEETING_LINK_SUCCESS,
		payload: response.data
	};
};

export const manageDsrZoomLinkFailure = (error) => {
	return {
		type: types.MANAGE_ZOOM_MEETING_LINK_FAILURE,
		error
	};
};

export const manageDsrZoomLinkRequest = () => {
	return {
		type: types.MANAGE_ZOOM_MEETING_LINK_REQUEST
	};
};

export function manageDsrZoomLink(manageDsrZoomLinkMetadata) {

	return async (dispatch) => {
		dispatch(manageDsrZoomLinkRequest());
		try {
			const url = `/integrations/zoom/dsr/manage`;
			const headers = await auth.getAccessToken();
			const response = await axiosInstance.post(
				url,
				{	manageDsrZoomLinkMetadata },
				{ headers }
			);

			if (typeof response.data.data.zoomLinkIsActive === "boolean") {
				dispatch(setDsrZoomLinkIsActive(response.data.data.zoomLinkIsActive))
			}
		
			dispatch(manageDsrZoomLinkSuccess(response));
		} catch (error) {
			dispatch(manageDsrZoomLinkFailure(error));
		}
	};
}

